<div class="layout-top-bar">
  <div class="layout-top-bar-logo-container">
    <!-- Hidden when there is no sidebar to toggle: an account without access
         to the platform has no menu, and a button that visibly does nothing
         reads as a broken app rather than a restricted one. -->
    @if (roleService.canAccessPlatform()) {
      <button class="layout-menu-button layout-top-bar-action" [class.active]="layoutService.isSidebarOpen()" (click)="layoutService.onMenuToggle()">
        <i class="pi pi-bars"></i>
      </button>
    }
    <a class="layout-top-bar-logo" routerLink="/">
      <app-logo-component />
    </a>
  </div>

  <div class="layout-top-bar-actions">
    <div class="layout-config-menu">
      <button type="button" class="layout-top-bar-action" i18n-pTooltip pTooltip="Tema" showDelay="1000" tooltipPosition="bottom" (click)="toggleDarkMode()">
        <i [ngClass]="{ 'pi ': true, 'pi-moon': layoutService.isDarkTheme(), 'pi-sun': !layoutService.isDarkTheme() }"></i>
      </button>
    </div>

    <button class="layout-top-bar-menu-button layout-top-bar-action" pStyleClass="@next" enterFromClass="hidden" enterActiveClass="animate-scalein" leaveToClass="hidden" leaveActiveClass="animate-fadeout" [hideOnOutsideClick]="true">
      <i class="pi pi-ellipsis-v"></i>
    </button>

    <div class="layout-top-bar-menu hidden xl:block">
      <div class="layout-top-bar-menu-content">
        <!-- Also off for an account without access to the platform: the agenda
             shows the sedute of patients it has no business seeing. -->
        <button type="button" class="layout-top-bar-action" i18n-pTooltip pTooltip="Calendario" showDelay="1000" tooltipPosition="bottom"
                [disabled]="!canViewCalendar || !roleService.canAccessPlatform()" (click)="calendarPanel.toggle($event)">
          <i class="pi pi-calendar"></i>
          <span i18n>Calendario</span>
        </button>
        <p-popover
          #calendarPanel
          styleClass="top-bar-agenda-popover"
          [style]="{ width: '365px' }"
          (onShow)="onCalendarPanelShow()">
          <app-day-agenda
            [date]="agendaDate()"
            [events]="agendaEvents()"
            (sessionClick)="onAgendaEventClick($event)" />
        </p-popover>
        <button disabled type="button" class="layout-top-bar-action"  i18n-pTooltip pTooltip="Messaggi" showDelay="1000" tooltipPosition="bottom">
          <i class="pi pi-envelope"></i>
          <span i18n>Messaggi</span>
        </button>
        <!-- Swapped for an inert button rather than given [disabled]: this is an
             anchor, and the disabled attribute does nothing on one: it would
             still navigate.
             Same classes so the toolbar does not reflow between the two states. -->
        @if (roleService.canAccessPlatform()) {
          <a routerLink="/app/profile" class="layout-top-bar-action" i18n-pTooltip pTooltip="Profilo" showDelay="1000" tooltipPosition="bottom">
            <i class="pi pi-user"></i>
            <span i18n>Profilo</span>
          </a>
        } @else {
          <button disabled type="button" class="layout-top-bar-action" i18n-pTooltip pTooltip="Profilo" showDelay="1000" tooltipPosition="bottom">
            <i class="pi pi-user"></i>
            <span i18n>Profilo</span>
          </button>
        }
        <button (click)="logout()" type="button" class="layout-top-bar-action" i18n-pTooltip pTooltip="Esci" showDelay="1000" tooltipPosition="bottom">
          <i class="pi pi-sign-out"></i>
          <span i18n>Esci</span>
        </button>
      </div>
    </div>
  </div>
</div>
